/* global TweenMax, TimelineMax, Sine, Elastic */

import { $, $$ } from '../../helper/utils';

// const menuWrapper = $('.navigation-wrapper');

// const elToTween = [];
// const navBtnsAndTitles = $$('.nav-title');

// // for invisible elements get the whole element otherwise just the title element
// for (let i = navBtnsAndTitles.length; i--;) {
//     const el = navBtnsAndTitles[i];
//     if (el.parentElement.classList.contains('nav-view-detail')) {
//         elToTween.push(el.parentElement);
//     } else {
//         elToTween.push(el);
//     }
// }

// const mainMenuTween = TweenMax.fromTo(menuWrapper, 0.5, {
//     y: '-100%',
//     autoAlpha: 1,
// }, {
//     y: '0%',
//     ease: Sine.easeOut,
//     paused: true,
//     pointerEvents: 'auto',
// });



// const btnTween = new TimelineMax({ paused: true });
// btnTween.staggerFromTo(elToTween, 0.5, {
//     scale: 0,
//     opacity: 0,
// }, {
//     scale: 1,
//     opacity: 1,
//     pointerEvents: 'auto',
//     ease: Elastic.easeOut.config(1, 0.5),
// }, 0.2);

const loginTween = new TimelineMax({
    paused: true,
});

loginTween.set('.sso-wrapper', { visibility: 'inherit', pointerEvents: 'auto' })
    .to('.sso-wrapper .backdrop', 0.25, { opacity: 1 })
    .fromTo('.sso-content', 0.275, { xPercent: 100 }, { xPercent: 0, ease: Sine.easeOut }, '-=.25');

export { loginTween };
